import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/en.json';
import translationRU from './locales/ru.json';

const resources = {
    en: {
        translation: translationEN,
    },
    ru: {
        translation: translationRU,
    },
};

const getLanguageFromDomain = () => {
    const hostname = window.location.hostname;
    if (hostname.startsWith('en.')) return 'en';
    if (hostname.startsWith('ru.')) return 'ru';
    return 'ru'; // язык по умолчанию
};

const language = getLanguageFromDomain();

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: language,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export { getLanguageFromDomain, language };
export default i18n;
